import LrComplexQuery from './_src/LrComplexQuery.vue'

LrComplexQuery.install = function(Vue) {
  Vue.component(LrComplexQuery.name, LrComplexQuery)
}

export default LrComplexQuery
